import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Fragment as _Fragment, vShow as _vShow, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "vue-sound" }
const _hoisted_2 = {
  key: 0,
  class: "player-image"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "player" }
const _hoisted_5 = { class: "player-controls" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "player-track" }
const _hoisted_8 = { class: "player-track-title" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "ellipsis"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 3,
  class: "player-track-title-details",
  nowrap: ""
}
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "player-track-time" }
const _hoisted_15 = { class: "player-track-time-current" }
const _hoisted_16 = { class: "player-track-time-total" }
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = ["loop", "src"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: $props.image,
            alt: $props.title
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        ($props.showSkip && !$props.livestream)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "player-back-15-icon",
              "aria-label": "go back 15 seconds",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.goBack15 && $options.goBack15(...args)))
            }, [
              _createVNode(_component_Icon, {
                icon: "arrow-left",
                width: "1.2rem",
                height: "1.2rem"
              })
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("a", {
          class: "player-play-pause-icon",
          "aria-label": $data.playing ? 'pause' : 'play',
          onClick: _cache[1] || (_cache[1] = (...args) => ($options.togglePlay && $options.togglePlay(...args)))
        }, [
          ($data.playing)
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                width: "1.2rem",
                height: "1.2rem",
                icon: "pause",
                fill: "#414651"
              }))
            : (_openBlock(), _createBlock(_component_Icon, {
                key: 1,
                width: "1.2rem",
                height: "1.2rem",
                icon: "play",
                fill: "#414651"
              }))
        ], 8 /* PROPS */, _hoisted_6),
        ($props.showSkip && !$props.livestream)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "player-ahead-15-icon",
              "aria-label": "go ahead 15 seconds",
              onClick: _cache[2] || (_cache[2] = (...args) => ($options.goAhead15 && $options.goAhead15(...args)))
            }, [
              _createVNode(_component_Icon, {
                icon: "arrow-right",
                width: "1.2rem",
                height: "1.2rem"
              })
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            ($options.hasTitle && $options.hasTitleLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: $props.titleLink,
                  class: "player-track-title-link"
                }, _toDisplayString($props.title), 9 /* TEXT, PROPS */, _hoisted_9))
              : _createCommentVNode("v-if", true),
            ($options.hasTitle && !$options.hasTitleLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($props.title), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($options.hasTitle && $options.hasDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, " • "))
              : _createCommentVNode("v-if", true),
            ($options.hasDetails && !$options.hasDetailsLink)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($props.details), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($options.hasDetails && $options.hasDetailsLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 4,
                  href: $props.detailsLink,
                  class: "player-track-title-details-link"
                }, _toDisplayString($props.details), 9 /* TEXT, PROPS */, _hoisted_13))
              : _createCommentVNode("v-if", true)
          ]),
          (!$props.livestream)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  ref: "progress",
                  class: "player-track-progress",
                  onClick: _cache[3] || (_cache[3] = _withModifiers((...args) => ($options.seek && $options.seek(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ width: $options.percentComplete + '%' }),
                    class: "player-track-seeker"
                  }, null, 4 /* STYLE */),
                  _createElementVNode("div", {
                    style: _normalizeStyle({ width: $options.percentBuffered + '%' }),
                    class: "player-track-buffered"
                  }, null, 4 /* STYLE */)
                ], 512 /* NEED_PATCH */),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString($options.convertTimeHHMMSS($data.currentSeconds)), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_16, _toDisplayString($options.convertTimeHHMMSS($data.durationSeconds)), 1 /* TEXT */)
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          class: "player-volume",
          onMouseover: _cache[7] || (_cache[7] = _withModifiers($event => ($data.showVolume = true), ["prevent"])),
          onMouseleave: _cache[8] || (_cache[8] = _withModifiers($event => ($data.showVolume = false), ["prevent"]))
        }, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "playerVolume",
            class: "hide-ally-element"
          }, " volume slider ", -1 /* HOISTED */)),
          _createVNode(_Transition, {
            name: "slide-left",
            persisted: ""
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                id: "playerVolume",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.volume) = $event)),
                type: "range",
                min: "0",
                max: "100"
              }, null, 512 /* NEED_PATCH */), [
                [_vShow, $data.showVolume],
                [_vModelText, $data.volume]
              ])
            ]),
            _: 1 /* STABLE */
          }),
          ($props.volumeChange)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                tabindex: "0",
                class: "player-volume-icon",
                "aria-label": $options.muted ? 'unmute' : 'mute',
                onClick: _cache[5] || (_cache[5] = (...args) => ($options.mute && $options.mute(...args))),
                onKeypress: _cache[6] || (_cache[6] = _withKeys((...args) => ($options.mute && $options.mute(...args)), ["space","enter"]))
              }, [
                ($options.muted)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 0,
                      icon: "volume-x",
                      width: "2rem",
                      height: "2rem",
                      stroke: "#414651"
                    }))
                  : (_openBlock(), _createBlock(_component_Icon, {
                      key: 1,
                      icon: "volume-plus",
                      width: "2rem",
                      height: "2rem",
                      stroke: "#414651"
                    }))
              ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_17))
            : _createCommentVNode("v-if", true)
        ], 32 /* NEED_HYDRATION */),
        ($props.showDownload && !$props.livestream)
          ? (_openBlock(), _createElementBlock("a", {
              key: 2,
              tabindex: "0",
              class: "player-download-icon",
              "aria-label": "download",
              onClick: _cache[9] || (_cache[9] = (...args) => ($options.download && $options.download(...args))),
              onKeypress: _cache[10] || (_cache[10] = _withKeys((...args) => ($options.download && $options.download(...args)), ["space","enter"]))
            }, [
              _createVNode(_component_Icon, {
                icon: "download-02",
                width: "2rem",
                height: "2rem",
                stroke: "var(--gray-600)",
                "stroke-width": "1"
              })
            ], 32 /* NEED_HYDRATION */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("audio", {
        ref: "audioFile",
        loop: $data.innerLoop,
        src: $props.file,
        preload: "auto",
        style: {"display":"none"}
      }, null, 8 /* PROPS */, _hoisted_18)
    ])
  ]))
}